import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Pageable } from '../shared/model/pageable.model';
import { Prestador } from '../shared/model/prestador.model';
import { PrestadorProcedimento } from '../shared/model/prestador-procedimento.model';

@Injectable()
export class PrestadorService {

  urlBasePrestadoresApi: string;
  urlBasePrestadoresProcedimentosApi: string;

  constructor(private http: HttpClient) {
    this.urlBasePrestadoresApi = `${environment.mouraAmmServerURL}/prestadores`;
    this.urlBasePrestadoresProcedimentosApi = `${environment.mouraAmmServerURL}/prestadores-procedimentos`;
  }

  listarPrestadores(pageable: Pageable, filtroNome: string): Observable<any> {
    const pageAtual = pageable.page - 1;

    let params = new HttpParams();
    params = params.set('page', pageAtual.toString());
    params = params.set('size', pageable.size.toString());
    params = params.set('sort', 'id,desc');

    if (filtroNome) {
      params = params.set('nome', filtroNome);
    }

    return this.http.get(`${this.urlBasePrestadoresApi}`, { params });
  }

  listarTodosPrestadores(): Observable<any> {
    return this.http.get(`${this.urlBasePrestadoresApi}/all`, {});
  }

  cadastrar(prestador: Prestador): Observable<any> {
    return this.http.post<Prestador>(`${this.urlBasePrestadoresApi}`, prestador);
  }

  alterar(prestador: Prestador): Observable<any> {
    return this.http.put<Prestador>(`${this.urlBasePrestadoresApi}/${prestador.id}`, prestador);
  }

  buscar(prestadorId: number): Observable<any> {
    return this.http.get(`${this.urlBasePrestadoresApi}/${prestadorId}`);
  }

  inativar(prestadorId: number): Observable<any> {
    return this.http.delete(`${this.urlBasePrestadoresApi}/${prestadorId}/inativar`);
  }

  ativar(prestadorId: number): Observable<any> {
    return this.http.put(`${this.urlBasePrestadoresApi}/${prestadorId}/ativo`, null);
  }

  listarEspecialidades(): Observable<any> {
    return this.http.get(`${this.urlBasePrestadoresApi}/especialidades`);
  }

  // Bloco de métodos abaixos são utilizados para realizar a associação dos procedimentos X prestadores

  /**
   * Método responsável por buscar os procedimentos por prestador.
   * @param prestadorId identificador do prestador.
   */
  buscarProcedimentosPorPrestador(prestadorId: number): Observable<any> {
    return this.http.get(`${this.urlBasePrestadoresProcedimentosApi}/por-prestador/${prestadorId}`, { });
  }

  associarProcedimento(prestProcedimento: PrestadorProcedimento, prestadorId: number): Observable<any> {
    return this.http.post<any>(`${this.urlBasePrestadoresProcedimentosApi}/associar-procedimentos/${prestadorId}`, prestProcedimento);
  }

  buscarProcedimentoPorPrestador(prestProcedimentoId: number): Observable<any> {
    return this.http.get(`${this.urlBasePrestadoresProcedimentosApi}/${prestProcedimentoId}`);
  }

  deletarProcedimentoPorPrestador(prestProcedimentoId: number): Observable<any> {
    return this.http.delete(`${this.urlBasePrestadoresProcedimentosApi}/${prestProcedimentoId}`);
  }
}
